import axios from "axios"

const fetchMessagesRequest = () => {
	return {type: "FETCH_MESSAGES_REQUEST"}
}

const fetchMessagesSuccess = (messages) => {
	return {type: "FETCH_MESSAGES_SUCCESS", payload: messages}
}

const fetchMessagesFailure = (error) => {
	return {type: "FETCH_MESSAGES_FAILURE", payload: error}
}

export const fetchMessages = () => {
	return (dispatch) => {
		dispatch(fetchMessagesRequest())
		axios.get("/admin/contact")
		.then(response => {
			const messages = response.data
			dispatch(fetchMessagesSuccess(messages))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchMessagesFailure(error))	
		})
	}
}

export const fetchMessagesPagination = (e) => {
	return (dispatch) => {
		dispatch(fetchMessagesRequest())
		axios.get(e)
		.then(response => {
			const messages = response.data
			dispatch(fetchMessagesSuccess(messages))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchMessagesFailure(error))	
		})
	}
}